import { render, staticRenderFns } from "./CambiosMagistrado.vue?vue&type=template&id=c2af3cd2&scoped=true"
import script from "./CambiosMagistrado.vue?vue&type=script&lang=js"
export * from "./CambiosMagistrado.vue?vue&type=script&lang=js"
import style0 from "./CambiosMagistrado.vue?vue&type=style&index=0&id=c2af3cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2af3cd2",
  null
  
)

export default component.exports